import { render, staticRenderFns } from "./InventoryLabResultView.vue?vue&type=template&id=2c626521"
import script from "./InventoryLabResultView.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports